import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path fill="#D8FFFF" d="M85.5 91.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      d="m103.62 75.5 3.94-3.94c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0c-.58.59-.59 1.54 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12z"
    />
    <path fill="#D8FFFF" d="M36.5 26.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#00D8D8"
      d="M21.5 34.93h-5.57v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57H7.36c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M17 71c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
    />
    <path
      fill="#0597A3"
      d="M83 69.39c0 3.1-2.35 5.61-5.25 5.61H38.24c-2.9 0-5.25-2.51-5.25-5.61V38.61c0-3.1 2.35-5.61 5.25-5.61h39.51c2.9 0 5.25 2.51 5.25 5.61z"
    />
    <path
      fill="#D8FFFF"
      d="m38.58 37.81 27.93-13.96c.93-.47 2.01-.54 3-.21s1.81 1.04 2.27 1.97l6.1 12.21H38.57z"
    />
    <path
      fill="#00D8D8"
      d="M86 68v6.12c0 3.25-2.63 5.88-5.88 5.88H35.87c-3.25 0-5.88-2.63-5.88-5.88V41.87c0-3.25 2.63-5.88 5.88-5.88h44.25c3.25 0 5.88 2.63 5.88 5.88v6.12"
    />
    <path
      fill="#0597A3"
      d="M87 68c2.21 0 4-1.79 4-4V52c0-2.21-1.79-4-4-4H77c-5.52 0-10 4.48-10 10s4.48 10 10 10z"
    />
    <path fill="#D8FFFF" d="M77 61a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
  </svg>
);
const SvgEnrichedIconWalletBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconWalletBrand);
export default Memo;
